
  import Vue from "vue";
  import PwaIcon from "@/components/common/PwaIcon.vue";
  import {COMPETITION_STATUS_ID} from "@/utils/competition";
  import {ROUTES} from "@/router/routes";
  import {getUserGamesSettings} from "@/utils/user";

  export default Vue.extend({
    name: "pwa-competition-round-match-result-user-box",
    components: {
      PwaIcon,
    },
    props: {
      user: {
        type: Object,
        required: true,
      },
      isWinner: {
        type: Boolean,
        required: true,
      },
      isVip: {
        type: Boolean,
        required: true,
      },
      promoted: {
        type: Boolean,
        required: true,
      },
      competitionStatusId: {
        type: Number,
        required: true,
      },
      nextPlayer: {
        type: Number,
        required: false,
        default: null,
      },
      OldMatch: {
        type: String,
        required: false,
        default: '',
      },
    },
    computed: {
      isCompetitionCancelled(): boolean {
        return this.competitionStatusId === COMPETITION_STATUS_ID.CANCELLED;
      },
      isCurrentUser(): boolean {
        return this.user?.user_id && this.user?.user_id === this.userId;
      },
      isWaitingUser(): boolean {
        return !this.user?.user_id;
      },
      userNamePath(): string {
        const routeLang = this.routeLang ? `/${this.routeLang}/` : '/';
        const username = this.user?.username;
        return username
          ? `${routeLang}${ROUTES.profile.path.replace(':username', encodeURIComponent(username))}`
          : '#';
      },
      userSettings(): any[] {
        return getUserGamesSettings(this.user?.settings || '');
      },
    },
    methods: {
      goToUserProfile() {
        const username = this.user?.username;
        if (username) {
          this.routerPush(ROUTES.profile.name, {username});
        }
      },
    },
  });
